import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { validateStoredUser } from "../../store/slices/userSlice";
import { setActiveWorkspaceFromToken } from "../../store/slices/workspaceSlice";
import type { AppDispatch } from "../../store/store";
import { getAuthUrl } from "@pl-flight-recorder/web/utils/authUtils";
import { selectDebugSettings } from "@pl-flight-recorder/web/store/slices/debugSlice";

const TokenPage: React.FC = () => {
  const { token, workspaceId } = useParams<{
    token: string;
    workspaceId?: string;
  }>();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  useEffect(() => {
    const handleToken = async () => {
      console.log("handleToken", token, workspaceId);
      if (!token) {
        console.error("No token provided");
        // navigate("/auth");
        return;
      }

      try {
        // Validate user first
        await dispatch(validateStoredUser(token)).unwrap();

        // If workspaceId is provided, set it along with the token
        console.log("token and workspaceId", token, workspaceId);
        if (token) {
          dispatch(
            setActiveWorkspaceFromToken({
              workspaceId: Number(workspaceId),
              token: token,
            }),
          );
        }

        // Navigate to home page after successful token handling
        navigate("/");
      } catch (error) {
        console.error("Failed to validate token:", error);
        console.log("getAuthUrl", getAuthUrl());
        const { disableAuthRedirect } = useSelector(selectDebugSettings);
        console.log("disableAuthRedirect", disableAuthRedirect);
        if (!disableAuthRedirect) {
          console.log("redirecting to auth");
          window.location.href = getAuthUrl();
        }
        return;
      }
    };

    handleToken();
  }, [token, workspaceId, dispatch, navigate]);

  useEffect(() => {
    if (token) {
      dispatch(validateStoredUser(token));
    }
  }, [dispatch, token]);

  return <div></div>;
};

export default TokenPage;
